export default {
	init() {
		const $form = $('#tr-delovni-cas-form')
		if ($form.length === 0) return

		$form.on('submit', function(e) {
			e.preventDefault()

			const $submitBtn = $form.find('button[type="submit"]')
			$submitBtn.prop('disabled', true)

			const formData = new FormData(this)
			const form_error_element = $form.find('.form-response.error')

			// Debug form data
			let objectContext = {}
			for (const [key, value] of formData) {
				objectContext[key]=value
			}
			// console.log(objectContext)

			$.ajax({
				url: my_ajax_object.ajax_url,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function (response) {
					if (response && response.success) {
						form_error_element.text('Podatki so shranjeni. Preusmerjamo vas na naslednji korak...').removeClass('hidden text-red border-red').addClass('success text-blue border-blue').show()

						setTimeout(function() {
							window.location.href = response.data.redirect;
						}, 1000)
					} else {
						form_error_element.text(response.data.error).removeClass('hidden')
						$submitBtn.prop('disabled', false)
					}

				},
				error: function (jqXHR, textStatus, errorThrown) {
					let msg = 'Napaka pri shranjevanju. Osvežite stran in poskusite znova.'
					if (jqXHR.responseJSON && jqXHR.responseJSON.data) {
						msg = jqXHR.responseJSON.data
					}

					form_error_element.text(msg).removeClass('hidden')
					$submitBtn.prop('disabled', false)
				}
			})
		})
	}
}
